export const CORE_CONFIG = {
  version: "1.0.1",
  voucher: {
    storageKeys: {
      voucher: "voucher",
      voucher2: "voucher2",
    },
  },
  services: {
    promo: {
      allowedPaths: ["", "products"],
    },
    paymentMethods: {
      allowedPaths: ["checkout", "assist-pay"],
    },
  },
};
